import React from "react";
import ReactFlow, { Controls, Background } from 'reactflow';
import 'reactflow/dist/style.css';

export default function dashboard() {

  // simple layout helper: splits items into columns with consistent spacing
  const layoutItems = (items, startX, startY, maxRowsPerColumn, options = {}) => {
    const rowGap = options.rowGap ?? 80;
    const colGap = options.colGap ?? 260;
    const width = options.width ?? 220;
    return items.map((item, index) => {
      const columnIndex = Math.floor(index / maxRowsPerColumn);
      const rowIndex = index % maxRowsPerColumn;
      return {
        id: item.id,
        data: { label: item.label },
        style: { background: '#fbf3bd', width },
        position: { x: startX + columnIndex * colGap, y: startY + rowIndex * rowGap },
      };
    });
  };

  const matrixNodes = [
    { id: "matrix-theme", data: { label: "Matrix Theme" }, style: { background: "#50ff8e", width: 120 }, position: { x: 0, y: 75 } },
    { id: "matrix-01", data: { label: "norskespilleautomater.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 200 } },
    { id: "matrix-02", data: { label: "irishluck.ie" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 250 } },
    { id: "matrix-03", data: { label: "habibibet.org" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 300 } },
    { id: "matrix-04", data: { label: "nät-casino.se" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 350 } },
    { id: "matrix-05", data: { label: "betamericalatina.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 400 } },
    { id: "matrix-06", data: { label: "casinon.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 450 } },
    { id: "matrix-14", data: { label: "superbonusschweiz.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 500 } },
    { id: "matrix-15", data: { label: "betting.livegoals.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y:  550 } },
    { id: "matrix-16", data: { label: "AFGA-Matrix" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 600 } },
    { id: "matrix-17", data: { label: "RBC-Matrix" }, style: { background: "#fbf3bd", width: 220 }, position: { x: -250, y: 650 } },
    { id: "matrix-18", data: { label: "meutimao (partnerships)" }, style: { background: "#c9b8f0", width: 220 }, position: { x: -250, y: 700 } },
    { id: "matrix-19", data: { label: "ODIA (partnerships)" }, style: { background: "#c9b8f0", width: 220 }, position: { x: -250, y: 750 } },

    { id: "matrix-label-01", data: { label: "South African Sites" }, style: { background: "#caffdd", width: 220 }, position: { x: 50, y: 200 } },
    { id: "matrix-07", data: { label: "playcasino.co.za" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 250 } },
    { id: "matrix-08", data: { label: "onlinegamblingsa.co.za" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 300 } },
    { id: "matrix-09", data: { label: "onlinecasinosouthafrica.net" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 350 } },
    { id: "matrix-10", data: { label: "onlinegamblingsa.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 400 } },
    { id: "matrix-11", data: { label: "free-casinos.co.za" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 450 } },
    { id: "matrix-12", data: { label: "casinomobile.co.za" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 500 } },
    { id: "matrix-13", data: { label: "onlinecasinosonline.co.za" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 50, y: 550 } },
  ]

  const rocketNodes = [
    { id: "rocket-theme", data: { label: "Rocket Theme" }, style: { background: "#73f5a1", width: 120 }, position: { x: 600, y: 75 } },
    { id: "rocket-02", data: { label: "casinossuisses.org" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 600, y: 200 } },
    { id: "rocket-03", data: { label: "casinosvizzera.org" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 600, y: 250 } },
  ];
  
  const sportsNodes = [
    { id: "sports-theme", data: { label: "Sports Theme" }, style: { background: "#73f5a1", width: 120 }, position: { x: 850, y: 75 } },
    { id: "sports-01", data: { label: "betbroz.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 850, y: 200 } },
    // { id: "sports-02", data: { label: "livegoals.com" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 850, y: 250 } },
    { id: "sports-03", data: { label: "sportwetten-bonus.de" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 850, y: 250 } },
  ];

  const cryptoNodes = [
    { id: "crypto-theme", data: { label: "Crypto Theme" }, style: { background: "#73f5a1", width: 120 }, position: { x: 1150, y: 75 } },
    // { id: "crypto-01", data: { label: "Bitedge" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 1150, y: 200 } },
    // { id: "crypto-02", data: { label: "coin-ratgeber.de" }, style: { background: "#fbf3bd", width: 220 }, position: { x: 1150, y: 250 } }
  ];

  const partnershipsThemeNode = { id: 'partnerships-theme', data: { label: 'Partnerships' }, style: { background: '#73f5a1', width: 140 }, position: { x: 1450, y: 75 } };
  const partnershipItems = [
    { id: 'partner-01', label: 'gmbl' },
    { id: 'partner-02', label: 'thesun' },
    { id: 'partner-03', label: 'talksport' },
    { id: 'partner-04', label: 'pressreleases' },
    { id: 'partner-05', label: 'thesun-ie' },
    { id: 'partner-06', label: 'thesun-us' },
    { id: 'partner-07', label: 'talksport-ie' },
    { id: 'partner-08', label: 'talksport-us' },
    { id: 'partner-09', label: 'deportesyapuestas' },
    { id: 'partner-10', label: 'pulzo' },
    { id: 'partner-11', label: 'crickettimes' },
    { id: 'partner-13', label: 'mysafegame' },
    { id: 'partner-14', label: 'thesun-aus' },
    { id: 'partner-15', label: 'opovo' },
    { id: 'partner-16', label: 'talksport-za' },
    { id: 'partner-17', label: 'thesun-ng' },
    { id: 'partner-18', label: 'thesun-za' },
    { id: 'partner-19', label: 'talksport-aus' },
    { id: 'partner-20', label: 'talksport-ng' },
    { id: 'partner-21', label: 'Calciomercato' },
    { id: 'partner-22', label: 'askgamblers' },
    { id: 'partner-23', label: 'thesun-ca' },
    { id: 'partner-24', label: 'thesun-on' },
    { id: 'partner-25', label: 'talksport-ca' },
    { id: 'partner-26', label: 'talksport-on' },
  ];
  const partnershipsSiteNodes = layoutItems(partnershipItems, 1350, 200, 10, { width: 220, rowGap: 50, colGap: 240 });
  const partnershipsNodes = [partnershipsThemeNode, ...partnershipsSiteNodes];

  const elements = [
    {
      id: "core-theme",
      data: { label: "Core theme" },
      style: { background: "#ffcc50", width: 100 },
      position: { x: 760, y: 0 },
    },
    ...rocketNodes,
    ...sportsNodes,
    ...matrixNodes,
    ...cryptoNodes,
    ...partnershipsNodes
  ];

  const edges = [
    { id: "edge-theme-01", source: "core-theme", target: "matrix-theme", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-theme-03", source: "core-theme", target: "rocket-theme", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-theme-04", source: "core-theme", target: "sports-theme", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-theme-05", source: "core-theme", target: "crypto-theme", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-theme-06", source: "core-theme", target: "partnerships-theme", animated: false, type: 'straight', arrowHeadType: 'arrow' },

    { id: "edge-matrix-00", source: "matrix-theme", target: "matrix-label-01", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-01", source: "matrix-theme", target: "matrix-01", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-02", source: "matrix-theme", target: "matrix-02", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-03", source: "matrix-theme", target: "matrix-03", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-04", source: "matrix-theme", target: "matrix-04", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-05", source: "matrix-theme", target: "matrix-05", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-06", source: "matrix-theme", target: "matrix-06", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-07", source: "matrix-theme", target: "matrix-07", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-08", source: "matrix-theme", target: "matrix-08", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-09", source: "matrix-theme", target: "matrix-09", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-10", source: "matrix-theme", target: "matrix-10", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-11", source: "matrix-theme", target: "matrix-11", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-12", source: "matrix-theme", target: "matrix-12", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-13", source: "matrix-theme", target: "matrix-13", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-14", source: "matrix-theme", target: "matrix-14", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-15", source: "matrix-theme", target: "matrix-15", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-16", source: "matrix-theme", target: "matrix-16", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-17", source: "matrix-theme", target: "matrix-17", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-18", source: "matrix-theme", target: "matrix-18", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-matrix-19", source: "matrix-theme", target: "matrix-19", animated: false, type: 'straight', arrowHeadType: 'arrow' },

    { id: "edge-rocket-02", source: "rocket-theme", target: "rocket-02", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-rocket-03", source: "rocket-theme", target: "rocket-03", animated: false, type: 'straight', arrowHeadType: 'arrow' },

    { id: "edge-sports-01", source: "sports-theme", target: "sports-01", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-sports-02", source: "sports-theme", target: "sports-02", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-sports-03", source: "sports-theme", target: "sports-03", animated: false, type: 'straight', arrowHeadType: 'arrow' },

    { id: "edge-crypto-01", source: "crypto-theme", target: "crypto-01", animated: false, type: 'straight', arrowHeadType: 'arrow' },
    { id: "edge-crypto-02", source: "crypto-theme", target: "crypto-02", animated: false, type: 'straight', arrowHeadType: 'arrow' },

    ...partnershipItems.map((it) => ({ id: `edge-${it.id}`, source: 'partnerships-theme', target: it.id, animated: false, type: 'straight', arrowHeadType: 'arrow' })),

  ]

  return <div style={{ height: '1200px' }}><ReactFlow nodes={elements} edges={edges}>
     <Background />
        <Controls />
  </ReactFlow></div>;
}
